"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeRefreshFetch = void 0;
var refresh_fetch_1 = require("./refresh-fetch");
Object.defineProperty(exports, "makeRefreshFetch", { enumerable: true, get: function () { return refresh_fetch_1.makeRefreshFetch; } });
//# sourceMappingURL=index.js.map